import { render, staticRenderFns } from "./explainDetaulModal.vue?vue&type=template&id=690f2551&scoped=true&"
import script from "./explainDetaulModal.vue?vue&type=script&lang=js&"
export * from "./explainDetaulModal.vue?vue&type=script&lang=js&"
import style0 from "./explainDetaulModal.vue?vue&type=style&index=0&id=690f2551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f2551",
  null
  
)

export default component.exports